class L extends HTMLElement {
  constructor() {
    super(), this.body = document.body, this.cartDrawer = document.querySelector("[data-cart-drawer]"), this.cartTriggers = document.querySelectorAll("[data-cart-trigger]"), this.closeButtons = document.querySelectorAll("[data-cart-drawer-close]"), this.overlayElement = null, this.cartRecommendations = this.querySelector(
      "[cart-drawer-recommendations]"
    ), document.addEventListener("cart:updated", () => {
      console.log("CartDrawer: cart:updated event received"), this.reloadCartItems(), this.loadRecommendations();
    }), document.addEventListener("cart:update", () => {
      console.log("CartDrawer: cart:update event received"), this.loadRecommendations();
    });
  }
  /**
   * Reloads the cart items section inside the drawer
   */
  async reloadCartItems() {
    if (console.log("CartDrawer: reloadCartItems called"), !this.cartDrawer) {
      console.log("CartDrawer: No cartDrawer found");
      return;
    }
    const e = this.cartDrawer.getAttribute("section-id");
    if (console.log("CartDrawer: sectionId for reloadCartItems", e), !e) return;
    const t = window.Shopify?.routes?.root || "/", r = `${t.endsWith("/") ? t : `${t}/`}?section_id=${e}`;
    console.log("CartDrawer: Fetching cart section from", r);
    try {
      const o = await fetch(r);
      if (!o.ok)
        throw new Error(`Cart section fetch failed: ${o.status}`);
      const i = await o.text(), n = document.createElement("div");
      n.innerHTML = i;
      const c = n.querySelector(".cart-drawer__items");
      c && this.cartDrawer.querySelector(".cart-drawer__items") && (this.cartDrawer.querySelector(".cart-drawer__items").innerHTML = c.innerHTML, console.log("CartDrawer: Cart items updated"));
      const d = n.querySelector(".cart-drawer__summary");
      d && this.cartDrawer.querySelector(".cart-drawer__summary") && (this.cartDrawer.querySelector(".cart-drawer__summary").innerHTML = d.innerHTML, console.log("CartDrawer: Cart summary updated"));
      const l = n.querySelector("[data-cart-drawer]")?.getAttribute("data-product-id");
      if (l)
        this.cartDrawer.setAttribute("data-product-id", l);
      else {
        this.cartDrawer.removeAttribute("data-product-id");
        const u = n.querySelector("[cart-drawer-recommendations]");
        u && this.cartRecommendations && (this.cartRecommendations.innerHTML = u.innerHTML);
      }
    } catch (o) {
      console.error("CartDrawer: Error reloading cart items", o);
    }
  }
  connectedCallback() {
    this.addEventListener("click", (e) => {
      const t = e.target.closest(".cart-drawer-rec__add");
      if (!t) return;
      const s = t.closest(".cart-drawer-rec__actions")?.querySelector(".cart-drawer-rec__select");
      s && this.addRecommendationToCart(t, s.value);
    }), this.cartTriggers.forEach((e) => {
      e.addEventListener("click", () => {
        document.body && document.body.dataset.template === "cart" || this.openDrawer();
      });
    }), this.closeButtons.forEach((e) => {
      e.addEventListener("click", () => this.closeDrawer());
    }), document.addEventListener("keydown", (e) => {
      e.key === "Escape" && this.isOpen() && this.closeDrawer();
    }), this.overlay && this.overlay.addEventListener("click", () => this.closeDrawer());
  }
  get overlay() {
    return this.overlayElement || (this.overlayElement = document.querySelector("[data-drawer-overlay]")), this.overlayElement;
  }
  isOpen() {
    return this.cartDrawer?.getAttribute("aria-expanded") === "true";
  }
  openDrawer() {
    if (this.cartDrawer) {
      console.log("CartDrawer: openDrawer called"), this.cartDrawer.setAttribute("aria-expanded", "true");
      const e = this.overlay;
      console.log("CartDrawer: overlay element found:", e), e ? (e.classList.add("active"), console.log("CartDrawer: active class added to overlay")) : console.error("CartDrawer: overlay element NOT FOUND in DOM"), this.body.classList.add("no-scrolling"), this.loadRecommendations();
    }
  }
  closeDrawer() {
    this.cartDrawer && (console.log("CartDrawer: closeDrawer called"), this.cartDrawer.setAttribute("aria-expanded", "false"), document.querySelector(".hd-SearchSuggestions_Outer")?.classList.contains("is-active") || this.overlay?.classList.remove("active"), this.body.classList.remove("no-scrolling"));
  }
  async loadRecommendations() {
    if (console.log("CartDrawer: loadRecommendations called"), !this.cartRecommendations) {
      console.log("CartDrawer: No recommendations container found");
      return;
    }
    let e = this.cartDrawer?.getAttribute("data-product-id");
    if (!e)
      try {
        e = (await fetch("/cart.js").then((c) => c.json())).items?.[0]?.product_id?.toString(), e && this.cartDrawer.setAttribute("data-product-id", e);
      } catch {
      }
    if (console.log("CartDrawer: productId for recommendations", e), !e) {
      console.log(
        "CartDrawer: No product ID in cart to base recommendations on"
      );
      return;
    }
    const t = this.cartRecommendations.dataset.sectionId;
    if (console.log("CartDrawer: sectionId for recommendations", t), !t) {
      console.log("CartDrawer: No section ID found for recommendations");
      return;
    }
    const s = window.Shopify?.routes?.root || "/", r = s.endsWith("/") ? s : `${s}/`, o = this.cartDrawer?.dataset.recommendationsCount || 4, i = `${r}recommendations/products?section_id=${t}&product_id=${e}&limit=${o}`;
    console.log(`CartDrawer: Loading recommendations from ${i}`);
    try {
      const n = await fetch(i);
      if (!n.ok)
        throw new Error(`Response status: ${n.status}`);
      const c = await n.text(), d = document.createElement("div");
      d.innerHTML = c;
      const l = d.querySelector(
        "[cart-drawer-recommendations]"
      ), u = this.querySelector("[cart-drawer-recommendations]") || this.cartRecommendations;
      u && (this.cartRecommendations = u), l && l.innerHTML.trim().length > 0 && u ? (u.innerHTML = l.innerHTML, console.log("CartDrawer: Recommendations loaded successfully")) : console.log("CartDrawer: Recommendations area empty in response");
    } catch (n) {
      console.error("CartDrawer: Error loading recommendations", n);
    }
  }
  async addRecommendationToCart(e, t) {
    const s = e.textContent;
    e.disabled = !0, e.textContent = "…";
    try {
      if (!(await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: t, quantity: 1 })
      })).ok) throw new Error("Add to cart failed");
      e.textContent = "✓", document.dispatchEvent(new CustomEvent("cart:updated")), setTimeout(() => {
        e.textContent = s, e.disabled = !1;
      }, 1200);
    } catch {
      e.textContent = "!", setTimeout(() => {
        e.textContent = s, e.disabled = !1;
      }, 2e3);
    }
  }
}
customElements.get("cart-drawer") || customElements.define("cart-drawer", L);
class E extends HTMLElement {
  constructor() {
    super(), this.body = document.body, this.customerAccountDrawer = document.querySelector(
      "[data-customer-account-drawer]"
    ), this.buttonTriggers = document.querySelectorAll(
      "[data-customer-account-trigger]"
    ), this.closeButtons = document.querySelectorAll(
      "[data-customer-account-drawer-close]"
    ), this.overlayElement = null;
  }
  /**
   * Reloads the cart items section inside the drawer
   */
  connectedCallback() {
    console.log("CustomerAccountDrawer: connectedCallback called"), this.buttonTriggers.forEach((e) => {
      e.addEventListener("click", () => {
        this.openDrawer();
      });
    }), this.closeButtons.forEach((e) => {
      e.addEventListener("click", () => this.closeDrawer());
    }), document.addEventListener("keydown", (e) => {
      e.key === "Escape" && this.isOpen() && this.closeDrawer();
    }), this.overlay && this.overlay.addEventListener("click", () => this.closeDrawer());
  }
  renderRecentlyViewed() {
    const e = document.getElementById(
      "customer-account-drawer-recently-viewed-wrapper"
    );
    if (!e) return;
    let t = e.querySelector("recently-viewed");
    t || (e.insertAdjacentHTML(
      "beforeend",
      `
        <recently-viewed
          class="recently-viewed__outer"
          data-section-id="${this.customerAccountDrawer?.getAttribute("section-id") || ""}"
          data-section-type="customer-account-drawer"
        >
          <div class="recently-viewed__inner">
            <h2 class="recently-viewed__title">${e.querySelector(".customer-account-drawer__recently-viewed-title")?.textContent || ""}</h2>
            <div class="recently-viewed__products"></div>
          </div>
        </recently-viewed>
      `
    ), t = e.querySelector("recently-viewed")), t && typeof t.renderProducts == "function" && t.renderProducts();
  }
  get overlay() {
    return this.overlayElement || (this.overlayElement = document.querySelector("[data-drawer-overlay]")), this.overlayElement;
  }
  isOpen() {
    return this.customerAccountDrawer?.getAttribute("aria-expanded") === "true";
  }
  openDrawer() {
    this.customerAccountDrawer && (this.customerAccountDrawer.setAttribute("aria-expanded", "true"), this.overlay?.classList.add("active"), this.body.classList.add("no-scrolling"), this.renderRecentlyViewed());
  }
  disconnectedCallback() {
    this._recentlyViewedRendered = !1;
  }
  closeDrawer() {
    this.customerAccountDrawer && (this.customerAccountDrawer.setAttribute("aria-expanded", "false"), document.querySelector(".hd-SearchSuggestions_Outer")?.classList.contains("is-active") || this.overlay?.classList.remove("active"), this.body.classList.remove("no-scrolling"));
  }
}
customElements.get("customer-account-drawer") || customElements.define("customer-account-drawer", E);
class q extends HTMLElement {
  constructor() {
    super(), this.searchInput = this.querySelector(".hd-SearchBar_Input"), this.predictiveSearch = this.querySelector("predictive-search"), this.onDocumentClick = this.onDocumentClick.bind(this), this.header = document.querySelector("#header-component");
  }
  connectedCallback() {
    if (!this.searchInput) return;
    this.searchInput.addEventListener("focus", () => this.addActiveClass()), document.addEventListener("click", this.onDocumentClick), this.addEventListener("search:closed", () => {
      this.removeActiveClass(), this.searchInput && this.searchInput.blur();
    });
    const e = this.querySelector("[data-search-close]");
    e && e.addEventListener("click", () => {
      this.removeActiveClass(), this.searchInput && (this.searchInput.value = ""), this.predictiveSearch && this.predictiveSearch.hideSuggestions(), this.searchInput.blur();
    }), this.addEventListener("click", (t) => t.stopPropagation());
  }
  disconnectedCallback() {
    document.removeEventListener("click", this.onDocumentClick);
  }
  onDocumentClick(e) {
    e.target.closest("search-bar") || (this.removeActiveClass(), this.searchInput && (this.searchInput.value = ""), this.predictiveSearch && this.predictiveSearch.hideSuggestions());
  }
  addActiveClass() {
    this.searchInput.classList.add("hd-SearchBar_Input--active"), this.header?.classList.add("header--search-active");
  }
  removeActiveClass() {
    this.searchInput.classList.remove("hd-SearchBar_Input--active"), this.header?.classList.remove("header--search-active");
  }
}
customElements.get("search-bar") || customElements.define("search-bar", q);
class k extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.container = this.querySelector(".recently-viewed__products"), this.container && (this.currentProduct = window.ShopifyAnalytics?.meta?.product || null, this.saveProduct(), this.renderProducts());
  }
  // Saves the current product to localStorage, ensuring no duplicates and a max of 8 items.
  saveProduct() {
    if (!this.currentProduct) return;
    const e = {
      id: this.currentProduct.id,
      title: this.currentProduct.title,
      handle: this.currentProduct.handle,
      price: this.currentProduct.price,
      url: `/products/${this.currentProduct.handle}`,
      image: this.currentProduct.image
    };
    let t = JSON.parse(localStorage.getItem("recentlyViewed")) || [];
    t = t.filter((s) => s.id !== e.id), t.unshift(e), t = t.slice(0, 8), localStorage.setItem("recentlyViewed", JSON.stringify(t));
  }
  // Fetches product card HTML for each recently viewed product and renders them in the container.
  async renderProducts() {
    if (this.container = this.querySelector(".recently-viewed__products"), !this.container) return;
    let e = JSON.parse(localStorage.getItem("recentlyViewed")) || [];
    if (console.log("Recently viewed products:", e), this.currentProduct && (e = e.filter((r) => r.id !== this.currentProduct.id)), !e.length) {
      this.style.display = "none";
      return;
    }
    e = e.slice(0, 4);
    const t = e.map(
      (r) => fetch(
        `${window.Shopify.routes.root}products/${r.handle}?section_id=section-rendering-product-card`
      ).then((o) => o.text())
    ), s = await Promise.all(t);
    this.container.innerHTML = s.join("");
  }
}
customElements.define("recently-viewed", k);
function x(a, e = window.themeMoneyFormat || "${{amount}}") {
  typeof a == "string" && (a = a.replace(".", ""));
  const t = (a / 100).toFixed(2), s = (a / 100).toFixed(0), r = t.replace(".", ","), o = s.replace(
    ".",
    ","
  );
  return e.replace("{{amount}}", t).replace("{{amount_no_decimals}}", s).replace("{{amount_with_comma_separator}}", r).replace(
    "{{amount_no_decimals_with_comma_separator}}",
    o
  );
}
const f = {
  fallback: "en-us",
  unsupportedPrefixes: ["ko-", "ja-", "zh-", "th-"]
};
class I extends HTMLElement {
  constructor() {
    super(), this.docBody = document.body, this.defaultContent = document.querySelector("#predictive-search-default"), this.input = this.querySelector('input[type="search"]'), this.resultsContainer = document.querySelector(
      "#predictive-search-results"
    ), this.suggestionsOuter = this.closest("search-bar")?.querySelector(
      ".hd-SearchSuggestions_Outer"
    ), this.overlayElement = null, this.closeButton = document.querySelector(
      ".predictive-search__close-button"
    ), this.resourceTypes = ["query", "product", "collection", "page", "article"], this.resultLimit = 10, this.locale = (this.getAttribute("locale") || document.documentElement.lang || "").toLowerCase(), this.onInput = this.onInput.bind(this), this.onFocus = this.onFocus.bind(this), this.hideSuggestions = this.hideSuggestions.bind(this);
  }
  get overlay() {
    return this.overlayElement || (this.overlayElement = document.querySelector("[data-drawer-overlay]")), this.overlayElement;
  }
  connectedCallback() {
    if (!this.input || !this.resultsContainer) {
      console.warn("[PredictiveSearch] Missing input or results container.");
      return;
    }
    this.input.addEventListener("input", this.onInput), this.input.addEventListener("focus", this.onFocus), this.closeButton && this.closeButton.addEventListener("click", this.hideSuggestions), this.overlay && (this.onOverlayClick = () => {
      this.suggestionsOuter?.classList.contains("is-active") && (this.hideSuggestions(), this.input && this.input.blur());
    }, this.overlay.addEventListener("click", this.onOverlayClick));
  }
  disconnectedCallback() {
    this.input && (this.input.removeEventListener("input", this.onInput), this.input.removeEventListener("focus", this.onFocus)), this.closeButton && this.closeButton.removeEventListener("click", this.hideSuggestions), this.overlay && this.onOverlayClick && this.overlay.removeEventListener("click", this.onOverlayClick);
  }
  onFocus() {
    this.input.value.trim().length < 2 ? this.showInitialState() : this.onInput({ target: this.input });
  }
  showInitialState() {
    this.docBody.classList.add("no-scroll"), requestAnimationFrame(() => this.overlay?.classList.add("active")), this.resultsContainer && (this.resultsContainer.classList.remove("is-active"), this.resultsContainer.innerHTML = ""), this.defaultContent && this.defaultContent.classList.add("is-active"), this.suggestionsOuter?.classList.add("is-active");
  }
  // Predictive search is only supported for a subset of storefront languages.
  // Korean, Japanese, Chinese, etc. are NOT supported and return 417
  // "Unsupported buyer locale". The #shopify-features tag is unreliable here (it
  // reports the theme's primary-language support, not the buyer locale), so we
  // check the current locale against the store's known-unsupported list instead.
  get predictiveSearchSupported() {
    const e = this.locale;
    return e ? !f.unsupportedPrefixes.some(
      (t) => e.startsWith(t)
    ) : !0;
  }
  async onInput(e) {
    const t = e.target.value.trim();
    if (t.length < 2) {
      this.showInitialState();
      return;
    }
    try {
      const s = await this.fetchSuggestions(t);
      this.showSuggestions(s, t);
    } catch (s) {
      console.error("[PredictiveSearch] Error fetching suggestions:", s), this.showSuggestions({
        error: "Error loading results. Please try again."
      });
    }
  }
  async fetchSuggestions(e) {
    const t = !this.predictiveSearchSupported, s = (window.Theme?.routes?.predictive_search_url || "/search/suggest") + ".json", r = `/${f.fallback}/search/suggest.json`, o = t ? r : s, i = new URL(o, window.location.origin);
    i.searchParams.set("q", e), i.searchParams.set("resources[type]", this.resourceTypes.join(",")), i.searchParams.set("resources[limit]", this.resultLimit);
    const n = await fetch(i, {
      headers: { Accept: "application/json" }
    });
    if (!n.ok)
      throw new Error(`HTTP error ${n.status}`);
    const c = await n.json();
    return t && this.rewriteLocaleUrls(
      c,
      f.fallback,
      this.locale
    ), c;
  }
  // Recursively rewrite relative `url` fields from one locale prefix to another,
  // e.g. "/en-us/products/..." -> "/ko-kr/products/...". Absolute URLs (e.g. CDN
  // image URLs) are left untouched because they don't start with the prefix.
  rewriteLocaleUrls(e, t, s) {
    if (!e || typeof e != "object" || !s || t === s)
      return;
    const r = `/${t}/`, o = `/${s}/`;
    for (const i of Object.keys(e)) {
      const n = e[i];
      i === "url" && typeof n == "string" && n.startsWith(r) ? e[i] = o + n.slice(r.length) : n && typeof n == "object" && this.rewriteLocaleUrls(n, t, s);
    }
  }
  showSuggestions(e, t) {
    if (this.docBody.classList.add("no-scroll"), this.overlay && requestAnimationFrame(() => this.overlay.classList.add("active")), this.defaultContent && this.defaultContent.classList.remove("is-active"), this.resultsContainer.classList.add("is-active"), this.suggestionsOuter?.classList.add("is-active"), e.error) {
      this.resultsContainer.innerHTML = `<p class="predictive-search-error">${e.error}</p>`;
      return;
    }
    if (!e.resources) {
      this.resultsContainer.innerHTML = "<p>No results found</p>";
      return;
    }
    const s = e.resources.results || e.resources, r = s.products || [], o = s.queries || [], i = s.collections || [], n = s.pages || [];
    if (!(r.length || o.length || i.length || n.length)) {
      const u = (Theme.translations.search_results_no_results || "No results found").replace(/\{\{\s*query\s*\}\}/g, this.escapeHtml(t));
      this.resultsContainer.innerHTML = `<p>${u}</p>`;
      return;
    }
    const d = r.length ? `<ul class="predictive-search-results">${r.map(this.productTemplate).join("")}</ul>` : "<p>No products found</p>", l = this.buildInfoColumn(o, i, n);
    this.resultsContainer.innerHTML = `
      <div class="predictive-search-columns">
        <div class="predictive-search-column predictive-search-column--products">
          <div class="predictive-search-column__header">
            <h3 class="predictive-search-column__title">${Theme.translations.matching_results}</h3>
            <a href="${Theme.routes?.search_url || "/search"}?q=${encodeURIComponent(t)}" class="view-all">${Theme.translations.view_all}</a>
          </div>
          ${d}
        </div>
        <div class="predictive-search-column predictive-search-column--info">
          ${l}
        </div>
      </div>
    `;
  }
  hideSuggestions() {
    this.docBody.classList.remove("no-scroll");
    const e = document.querySelector("[data-cart-drawer]")?.getAttribute("aria-expanded") === "true", t = document.querySelector("[data-customer-account-drawer]")?.getAttribute("aria-expanded") === "true";
    this.overlay && !e && !t && this.overlay.classList.remove("active"), this.resultsContainer.innerHTML = "", this.resultsContainer.classList.remove("is-active"), this.defaultContent && this.defaultContent.classList.remove("is-active"), this.suggestionsOuter?.classList.remove("is-active"), this.dispatchEvent(new CustomEvent("search:closed", { bubbles: !0 }));
  }
  buildInfoColumn(e, t, s) {
    const r = [];
    if (e.length) {
      const o = e.map(
        (i) => `
          <li class="predictive-search-info-item">
            <a href="${Theme.routes?.search_url || "/search"}?q=${encodeURIComponent(i.text)}" class="predictive-search-info-link">
              ${i.styled_text || i.text}
            </a>
          </li>`
      ).join("");
      r.push(`
        <div class="predictive-search-info-section">
          <h3 class="predictive-search-column__title">${Theme.translations.search_suggestions}</h3>
          <ul class="predictive-search-info-list">${o}</ul>
        </div>
      `);
    }
    if (t.length) {
      const o = t.map(
        (i) => `
          <li class="predictive-search-info-item">
            <a href="${i.url}" class="predictive-search-info-link">${i.title}</a>
          </li>`
      ).join("");
      r.push(`
        <div class="predictive-search-info-section">
          <h3 class="predictive-search-column__title">${Theme.translations.collection_results}</h3>
          <ul class="predictive-search-info-list">${o}</ul>
        </div>
      `);
    }
    if (s.length) {
      const o = s.map(
        (i) => `
          <li class="predictive-search-info-item">
            <a href="${i.url}" class="predictive-search-info-link">${i.title}</a>
          </li>`
      ).join("");
      r.push(`
        <div class="predictive-search-info-section">
          <h3 class="predictive-search-column__title">${Theme.translations.useful_pages}</h3>
          <ul class="predictive-search-info-list">${o}</ul>
        </div>
      `);
    }
    return r.join("");
  }
  escapeHtml(e) {
    const t = document.createElement("div");
    return t.textContent = e, t.innerHTML;
  }
  productTemplate(e) {
    const t = e.featured_image ? `<img src="${e.featured_image.url}" alt="${e.featured_image.alt || e.title}" loading="lazy" class="predictive-search-img">` : "";
    return `
      <li class="predictive-search-item">
          <a href="${e.url}" class="predictive-search-content">
            <div class="predictive-search-image">${t}</div>
            <div class="predictive-search-info">
              <h3 class="predictive-search-title">${e.title}</h3>
              <p class="predictive-search-price">${x(e.price)}</p>
            </div>
            </a>
      </li>
    `;
  }
}
customElements.get("predictive-search") || customElements.define("predictive-search", I);
const A = ["boandtee.com", "www.boandtee.com"];
class T extends HTMLElement {
  constructor() {
    super();
    const e = (t, s, r) => {
      const o = this.querySelector(`[aria-controls="${s}"]`);
      return {
        kind: r,
        input: this.querySelector(`input[name="${t}"]`),
        button: o,
        panel: this.querySelector(`#${s}`),
        label: o ? o.querySelector(".localization-dropdown__label") : null
      };
    };
    this.lastOpenedDropdown = null, this.dropdowns = [
      e("country_code", "CountryList", "country"),
      e("language_code", "LanguageList", "language")
    ].filter((t) => t.input && t.button && t.panel), this.dropdowns.forEach((t) => {
      t.button.addEventListener("click", () => this.openSelector(t)), t.button.addEventListener("focusout", (s) => this.closeSelector(s, t)), t.panel.querySelectorAll("a").forEach(
        (s) => s.addEventListener("click", (r) => this.onItemClick(r, t))
      );
    }), this.buttonTrigger = this.querySelectorAll(
      ".localization-dropdown__trigger"
    ), this.addEventListener("keyup", this.onContainerKeyUp.bind(this)), this.hasSeenModal = localStorage.getItem("hasSeenLocalizationModal");
  }
  // The US site geo-redirects visitors to their correct market, so anyone
  // arriving from it has already been routed and shouldn't be prompted again.
  get cameFromUsSite() {
    try {
      return !!document.referrer && A.includes(new URL(document.referrer).hostname);
    } catch {
      return !1;
    }
  }
  connectedCallback() {
    if (console.log("LocalizationForm: Connected to DOM"), this.countryModal = document.querySelector(".localization-modal"), !this.countryModal) {
      console.error("Modal not found");
      return;
    }
    if (this.closeModalBtn = this.countryModal.querySelector(
      ".localization-modal__close"
    ), !this.closeModalBtn) {
      console.error("Close button not found");
      return;
    }
    if (this.buttonTrigger.forEach((e) => {
      e.addEventListener("click", this.openModal.bind(this));
    }), this.closeModalBtn.addEventListener("click", this.closeModal.bind(this)), sessionStorage.getItem("localizationModalReopen") === "true") {
      sessionStorage.removeItem("localizationModalReopen"), this.openModal();
      return;
    }
    if (this.cameFromUsSite) {
      localStorage.setItem("hasSeenLocalizationModal", "true"), this.hasSeenModal = !0;
      return;
    }
    this.hasSeenModal || this.checkUserLocation();
  }
  async checkUserLocation() {
    try {
      const s = (await (await fetch(
        window.Shopify.routes.root + "browsing_context_suggestions.json"
      )).json()).detected_values.country.handle, r = this.querySelector(
        'input[name="country_code"]'
      ), o = r ? r.value : null;
      s && o && s !== o && this.openModal(), localStorage.setItem("hasSeenLocalizationModal", "true"), this.hasSeenModal = !0;
    } catch (e) {
      console.error("Error detecting location:", e), this.openModal(), localStorage.setItem("hasSeenLocalizationModal", "true"), this.hasSeenModal = !0;
    }
  }
  openModal() {
    this.countryModal.classList.add("localization-modal-visible"), this.countryModal.setAttribute("aria-hidden", "false"), document.body.classList.add("fixed");
  }
  closeModal() {
    this.countryModal.classList.remove("localization-modal-visible"), this.countryModal.setAttribute("aria-hidden", "true"), document.body.classList.remove("fixed");
  }
  hidePanel(e) {
    e.button.setAttribute("aria-expanded", "false"), e.panel.setAttribute("hidden", !0);
  }
  onContainerKeyUp(e) {
    e.code.toUpperCase() === "ESCAPE" && (this.dropdowns.forEach((t) => this.hidePanel(t)), this.lastOpenedDropdown && this.lastOpenedDropdown.button.focus());
  }
  onItemClick(e, t) {
    e.preventDefault(), t.input.value = e.currentTarget.dataset.value, t.kind === "country" && sessionStorage.setItem("localizationModalReopen", "true");
    const s = this.querySelector("form");
    s && s.submit();
  }
  openSelector(e) {
    e.button.focus(), this.lastOpenedDropdown = e, e.panel.toggleAttribute("hidden"), e.button.setAttribute(
      "aria-expanded",
      (e.button.getAttribute("aria-expanded") === "false").toString()
    );
  }
  closeSelector(e, t) {
    const s = e.relatedTarget && e.relatedTarget.nodeName === "BUTTON";
    (e.relatedTarget === null || s) && this.hidePanel(t);
  }
}
customElements.define("localization-form", T);
class D extends HTMLElement {
  connectedCallback() {
    console.log("size guide toggle connected"), this.checkbox = this.querySelector(".size-guide__checkbox"), this.units = this.querySelectorAll(".unit"), this.setUnit("cm"), this.checkbox.addEventListener("change", () => {
      const e = this.checkbox.checked ? "in" : "cm";
      this.setUnit(e);
    });
  }
  setUnit(e) {
    this.units.forEach((t) => {
      t.style.display = t.classList.contains(`unit-${e}`) ? "inline" : "none";
    });
  }
}
customElements.define("size-guide-toggle", D);
class M extends HTMLElement {
  constructor() {
    super(), this.onDocClick = this.onDocClick.bind(this), this.onKeydown = this.onKeydown.bind(this), this.toggleMenu = this.toggleMenu.bind(this);
  }
  connectedCallback() {
    this.btn = this.querySelector(".social-share__trigger"), this.menu = this.querySelector(".social-share__menu"), !(!this.btn || !this.menu) && (this.items = Array.from(this.menu.querySelectorAll('a[role="menuitem"]')), this.btn.addEventListener("click", this.toggleMenu), this.items.forEach((e) => {
      e.addEventListener("click", () => this.closeMenu()), e.addEventListener("keydown", (t) => {
        (t.key === " " || t.key === "Enter") && (t.preventDefault(), e.click());
      });
    }));
  }
  disconnectedCallback() {
    this.btn?.removeEventListener("click", this.toggleMenu), this.removeGlobalListeners();
  }
  getUrl = () => encodeURIComponent(location.href);
  getTitle = () => encodeURIComponent(document.title);
  hydrateLinks = () => {
    const e = this.dataset.shareImage || "", t = this.getUrl(), s = this.getTitle(), r = this.menu.querySelector("[data-share-fb]"), o = this.menu.querySelector("[data-share-x]"), i = this.menu.querySelector("[data-share-pin]"), n = this.menu.querySelector("[data-share-email]");
    r && (r.href = `https://www.facebook.com/sharer/sharer.php?u=${t}`), o && (o.href = `https://twitter.com/intent/tweet?text=${s}&url=${t}`), i && (i.href = `https://pinterest.com/pin/create/button/?url=${t}` + (e ? `&media=${encodeURIComponent(e)}` : "") + `&description=${s}`), n && (n.href = `mailto:?subject=${s}&body=${t}`);
  };
  openMenu() {
    this.hydrateLinks(), this.menu.classList.remove("is-hidden"), this.btn.setAttribute("aria-expanded", "true"), this.items?.[0]?.focus({ preventScroll: !0 }), this.addGlobalListeners();
  }
  closeMenu() {
    this.menu.classList.add("is-hidden"), this.btn.setAttribute("aria-expanded", "false"), this.removeGlobalListeners();
  }
  toggleMenu(e) {
    e.preventDefault(), !this.menu.classList.contains("is-hidden") ? this.closeMenu() : this.openMenu();
  }
  addGlobalListeners() {
    document.addEventListener("click", this.onDocClick), document.addEventListener("touchstart", this.onDocClick), document.addEventListener("keydown", this.onKeydown);
  }
  removeGlobalListeners() {
    document.removeEventListener("click", this.onDocClick), document.removeEventListener("touchstart", this.onDocClick), document.removeEventListener("keydown", this.onKeydown);
  }
  onDocClick(e) {
    this.contains(e.target) || this.closeMenu();
  }
  onKeydown(e) {
    e.key === "Escape" && (e.preventDefault(), this.closeMenu(), this.btn.focus()), e.key === "ArrowDown" && (e.preventDefault(), this.focusNext(1)), e.key === "ArrowUp" && (e.preventDefault(), this.focusNext(-1));
  }
  focusNext(e) {
    if (!this.items.length) return;
    const s = (this.items.indexOf(document.activeElement) + e + this.items.length) % this.items.length;
    this.items[s].focus();
  }
}
customElements.get("social-share") || customElements.define("social-share", M);
class $ extends HTMLElement {
  /** @type {AbortController | null} */
  #e = null;
  connectedCallback() {
    this.input = this.querySelector("input"), this.errorElement = this.querySelector("#pcc-error"), this.input && (this.input.addEventListener("input", (e) => this.validateOnInput(e)), this.input.addEventListener("change", (e) => this.updatePccField(e)));
  }
  /**
   * Immediate validation to show/hide the error message while typing.
   */
  validateOnInput(e) {
    const t = e.target.value, s = /^P[0-9]{12}$/;
    t.length > 0 && !s.test(t) ? this.errorElement.style.display = "block" : this.errorElement.style.display = "none";
  }
  /**
   * Simple debounce implementation
   */
  #t(e, t) {
    let s;
    return (...r) => {
      clearTimeout(s), s = setTimeout(() => e.apply(this, r), t);
    };
  }
  /**
   * Handles updates to the PCC field and syncs it with the cart attributes.
   * @param {Event} event - The change event from the text field.
   */
  updatePccField = this.#t(async (e) => {
    const t = e.target;
    if (!(t instanceof HTMLInputElement)) return;
    const s = t.value;
    if (!/^P[0-9]{12}$/.test(s)) {
      console.warn("PCC Sync skipped: Invalid format."), this.errorElement.style.display = "block";
      return;
    }
    console.log("Valid PCC entered. Syncing cart attribute:", s), this.#e && this.#e.abort();
    const o = new AbortController();
    this.#e = o;
    try {
      const i = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          attributes: {
            "Personal Customs Code": s
          }
        }),
        signal: o.signal
      });
      if (!i.ok) throw new Error("Network response was not ok");
      const n = await i.json();
      console.log("Cart updated with Personal Customs Code. New attributes:", n.attributes);
    } catch (i) {
      i.name !== "AbortError" && console.error("Failed to update PCC cart attribute:", i);
    } finally {
      this.#e = null;
    }
  }, 200);
}
customElements.get("cart-pcc-field") || customElements.define("cart-pcc-field", $);
class z extends HTMLElement {
  connectedCallback() {
    const e = this.closest("product-card");
    this._qbs = e?.querySelector("quick-buy-sizes") || null, this._sizeIndex = this._qbs?._sizeIndex ?? parseInt(this.dataset.sizeIndex || "1", 10), this._colorIndex = this._qbs?._colorIndex ?? parseInt(this.dataset.colorIndex || "2", 10), this._fitIndex = this._qbs?._fitIndex ?? parseInt(this.dataset.fitIndex || "0", 10), this._marketKey = this._qbs?._marketKey ?? this.dataset.marketKey ?? null, this._selectedSize = null, this._selectedFit = null, this._page = "size", this._variants = this._qbs?._variants?.length ? this._qbs._variants : this._parse(this.dataset.variants, []), this._selectedColor = this._qbs?._selectedColor ?? this.dataset.selectedColor ?? null, window.globalQuickBuyVariantCache || (window.globalQuickBuyVariantCache = /* @__PURE__ */ new Map()), this._variantCache = window.globalQuickBuyVariantCache;
    const t = this.dataset.productHandle;
    t && this._variants.length && this._variantCache.set(t, { variants: this._variants }), this.querySelectorAll(".qbm-colour[data-variants]").forEach((s) => {
      const r = s.dataset.productHandle;
      if (r && !this._variantCache.has(r)) {
        const o = this._parse(s.dataset.variants, null);
        o && this._variantCache.set(r, { variants: o });
      }
    }), this._trigger = this.querySelector(".quick-buy__trigger"), this._popup = this.querySelector(".qbm-popup"), this._backdrop = this.querySelector(".qbm-popup__backdrop"), this._closeBtn = this.querySelector(".qbm-popup__close"), this._feedback = this.querySelector(".qbm-popup__feedback"), this._popup && (this._paged = this._popup.querySelector(".qbm-popup__paged"), this._multiAxis = !!this._paged, this._multiAxis && (this._sizeOptions = this._paged.querySelector(
      ".qbm-page--size .qbm-page__options"
    ), this._fitOptions = this._paged.querySelector(
      ".qbm-page--fit .qbm-page__options"
    )), this._trigger?.addEventListener("click", (s) => {
      s.preventDefault(), s.stopPropagation(), this._open();
    }), this._closeBtn?.addEventListener("click", () => this._close()), this._backdrop?.addEventListener("click", () => this._close()), document.addEventListener("keydown", (s) => {
      if (s.key === "Escape" && !this._popup.hidden) {
        this._close();
        return;
      }
      if (s.key === "Tab" && !this._popup.hidden) {
        const r = Array.from(
          this._popup.querySelectorAll(
            'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
          )
        ).filter((n) => !n.closest("[hidden]"));
        if (!r.length) {
          s.preventDefault();
          return;
        }
        const o = r[0], i = r[r.length - 1];
        s.shiftKey && document.activeElement === o ? (s.preventDefault(), i.focus()) : !s.shiftKey && document.activeElement === i && (s.preventDefault(), o.focus());
      }
    }), this._popup.addEventListener("click", (s) => this._onPopupClick(s)));
  }
  // ─── Helpers ──────────────────────────────────────────────────────────────
  _parse(e, t) {
    try {
      return JSON.parse(e || "null") ?? t;
    } catch {
      return t;
    }
  }
  _esc(e) {
    return e == null ? "" : String(e).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }
  // ─── Open / Close ─────────────────────────────────────────────────────────
  _open() {
    if (!this._popup) return;
    document.body.appendChild(this._popup), this._popup.hidden = !1, document.body.classList.add("no-scrolling"), this._resetPaged();
    const e = this.closest("product-card");
    e && e.classList.add("is-active"), requestAnimationFrame(() => {
      this._popup.classList.add("qbm-popup--open"), (this._closeBtn || this._popup.querySelector("button:not([disabled])"))?.focus();
    });
  }
  _close() {
    if (!this._popup) return;
    this._popup.classList.remove("qbm-popup--open");
    const e = () => {
      this._popup.hidden = !0, document.body.classList.remove("no-scrolling");
      const t = this.closest("product-card");
      t && t.classList.remove("is-active"), this.appendChild(this._popup), this._popup.removeEventListener("transitionend", e), this._trigger?.focus();
    };
    this._popup.addEventListener("transitionend", e);
  }
  // ─── Delegated click handler ───────────────────────────────────────────────
  _onPopupClick(e) {
    const t = e.target.closest(".qbm-colour");
    if (t) {
      e.stopPropagation(), this._handleColourClick(t);
      return;
    }
    if (this._multiAxis) {
      const r = e.target.closest(".qbm-page__nav");
      if (r && !r.disabled) {
        e.stopPropagation(), this._goToPage(
          r.classList.contains("qbm-page__nav--next") ? "fit" : "size"
        );
        return;
      }
      const o = e.target.closest(".qbm-fit__btn");
      if (o && !o.disabled && !o.hasAttribute("data-adding")) {
        e.stopPropagation(), this._handleFitSelect(o);
        return;
      }
      const i = e.target.closest(".qbm-size__btn");
      i && !i.disabled && (e.stopPropagation(), this._handleSizeSelect(i));
      return;
    }
    const s = e.target.closest(".qbm-size__btn");
    s && !s.disabled && !s.hasAttribute("data-adding") && (e.stopPropagation(), this._addToCart(s));
  }
  // ─── Multi-axis (Size + Fit) paged flow ────────────────────────────────────
  /** @param {"size"|"fit"} page */
  _goToPage(e) {
    this._page = e, this._paged && (this._paged.dataset.page = e);
  }
  _resetPaged() {
    this._multiAxis && (this._selectedSize = null, this._selectedFit = null, this._goToPage("size"), this._sizeOptions?.querySelectorAll(".qbm-size__btn--active").forEach((e) => e.classList.remove("qbm-size__btn--active")));
  }
  /** @param {HTMLButtonElement} btn */
  _handleSizeSelect(e) {
    this._selectedSize = e.dataset.sizeValue, this._sizeOptions?.querySelectorAll(".qbm-size__btn").forEach(
      (t) => t.classList.toggle("qbm-size__btn--active", t === e)
    ), this._refreshFitAvailability(), this._goToPage("fit");
  }
  _refreshFitAvailability() {
    if (!this._fitOptions) return;
    const e = this._selectedColor?.trim().toLowerCase(), t = this._selectedSize?.trim().toLowerCase();
    this._fitOptions.querySelectorAll(".qbm-fit__btn").forEach((s) => {
      const r = s.dataset.fitValue?.trim().toLowerCase(), o = this._variants.some(
        (i) => i.av && i[`op${this._sizeIndex}`]?.trim().toLowerCase() === t && i[`op${this._fitIndex}`]?.trim().toLowerCase() === r && (!e || i[`op${this._colorIndex}`]?.trim().toLowerCase() === e)
      );
      s.disabled = !o, s.classList.toggle("qbm-size__btn--unavailable", !o);
    });
  }
  /** @param {HTMLButtonElement} btn */
  _handleFitSelect(e) {
    if (!this._selectedSize) {
      this._goToPage("size");
      return;
    }
    this._selectedFit = e.dataset.fitValue;
    const t = this._resolveVariant(this._selectedSize, this._selectedFit);
    if (!t) {
      console.warn(
        "[QuickBuyMobile] Could not resolve variant for selected colour/size/fit"
      );
      return;
    }
    this._addResolvedVariant(e, t);
  }
  /**
   * @param {string|null} size
   * @param {string|null} fit
   * @returns {object|undefined}
   */
  _resolveVariant(e, t) {
    const s = this._selectedColor?.trim().toLowerCase(), r = e?.trim().toLowerCase(), o = t?.trim().toLowerCase();
    return this._variants.find(
      (i) => i[`op${this._sizeIndex}`]?.trim().toLowerCase() === r && i[`op${this._fitIndex}`]?.trim().toLowerCase() === o && (!s || i[`op${this._colorIndex}`]?.trim().toLowerCase() === s)
    );
  }
  /** Rebuild both pages' options for the current colour, then reset to step 1. */
  _rebuildMultiAxis() {
    const e = this._selectedColor?.trim().toLowerCase(), t = (n) => !e || n[`op${this._colorIndex}`]?.trim().toLowerCase() === e, s = [], r = /* @__PURE__ */ new Set(), o = [], i = /* @__PURE__ */ new Set();
    this._variants.forEach((n) => {
      const c = n[`op${this._sizeIndex}`]?.trim();
      c && !r.has(c) && (r.add(c), s.push(c));
      const d = n[`op${this._fitIndex}`]?.trim();
      d && !i.has(d) && (i.add(d), o.push(d));
    }), this._sizeOptions && (this._sizeOptions.innerHTML = s.map((n) => {
      const c = n.toLowerCase(), d = this._variants.some(
        (l) => l.av && l[`op${this._sizeIndex}`]?.trim().toLowerCase() === c && t(l)
      );
      return `<li class="qbm-size"><button type="button" class="qbm-size__btn${d ? "" : " qbm-size__btn--unavailable"}" data-size-value="${this._esc(n)}" ${d ? "" : "disabled"}>${this._esc(n)}</button></li>`;
    }).join("")), this._fitOptions && (this._fitOptions.innerHTML = o.map((n) => {
      const c = n.toLowerCase(), d = this._variants.some(
        (l) => l.av && l[`op${this._fitIndex}`]?.trim().toLowerCase() === c && t(l)
      );
      return `<li class="qbm-size"><button type="button" class="qbm-size__btn qbm-fit__btn${d ? "" : " qbm-size__btn--unavailable"}" data-fit-value="${this._esc(n)}" ${d ? "" : "disabled"}>${this._esc(n)}</button></li>`;
    }).join("")), this._resetPaged();
  }
  /**
   * Add a variant resolved from the colour + size + fit selection.
   * @param {HTMLButtonElement} btn
   * @param {object} variant
   */
  async _addResolvedVariant(e, t) {
    const s = {
      _pim_product_id: t.pid ?? e.dataset.pimProductId ?? ""
    };
    this._submitAddToCart(e, String(t.id), s);
  }
  // ─── Colour selection ──────────────────────────────────────────────────────
  async _handleColourClick(e) {
    this._popup.querySelectorAll(".qbm-colour").forEach((i) => {
      const n = i === e;
      i.classList.toggle("qbm-colour--active", n), i.setAttribute("aria-pressed", String(n));
    });
    const t = e.dataset.swatchType;
    if (t === "current") {
      const i = this.dataset.productHandle;
      i && this._variantCache.has(i) && (this._variants = this._variantCache.get(i).variants), this._selectedColor = this.dataset.selectedColor ?? null, this._rebuildSizes();
      return;
    }
    if (t === "option") {
      this._selectedColor = e.dataset.colorValue ?? null, this._rebuildSizes();
      return;
    }
    const s = e.dataset.productHandle, r = e.dataset.productUrl, o = e.dataset.pimProductId ?? "";
    if (s && this._variantCache.has(s)) {
      const i = this._variantCache.get(s);
      this._variants = i.variants, this._selectedColor = i.variants[0]?.[`op${this._colorIndex}`] ?? null, this._rebuildSizes();
      return;
    }
    if (e.dataset.variants) {
      const i = this._parse(e.dataset.variants, null);
      if (i?.length) {
        s && this._variantCache.set(s, { variants: i }), this._variants = i, this._selectedColor = i[0]?.[`op${this._colorIndex}`] ?? null, this._rebuildSizes();
        return;
      }
    }
    r && (await this._fetchVariants(s, r, o), this._rebuildSizes());
  }
  async _fetchVariants(e, t, s = "") {
    if (this._qbs && typeof this._qbs._fetchProductVariants == "function") {
      if (await this._qbs._fetchProductVariants(e, t, !1, s), e && this._variantCache.has(e)) {
        const r = this._variantCache.get(e);
        this._variants = r.variants, this._selectedColor = r.variants[0]?.[`op${this._colorIndex}`] ?? null;
      }
      return;
    }
    try {
      const r = await fetch(`${t}.js`);
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const i = (await r.json()).variants.map((n) => ({
        id: n.id,
        op1: n.option1,
        op2: n.option2,
        op3: n.option3,
        av: n.available,
        img: n.featured_image?.src ?? null,
        pid: s
      }));
      e && this._variantCache.set(e, { variants: i }), this._variants = i, this._selectedColor = i[0]?.[`op${this._colorIndex}`] ?? null;
    } catch (r) {
      console.error("[QuickBuyMobile] Fetch failed:", r);
    }
  }
  // ─── Rebuild size buttons ──────────────────────────────────────────────────
  _rebuildSizes() {
    if (this._multiAxis) {
      this._rebuildMultiAxis();
      return;
    }
    const e = this._popup.querySelector(".qbm-popup__sizes");
    if (!e) return;
    const t = /* @__PURE__ */ new Map();
    if (this._variants.forEach((o) => {
      const i = o[`op${this._sizeIndex}`]?.trim();
      i && !t.has(i) && t.set(i, o);
    }), !t.size) {
      e.innerHTML = '<li class="qbm-size"><button class="qbm-size__btn qbm-size__btn--unavailable" disabled>—</button></li>';
      return;
    }
    let s = this._variants;
    if (this._selectedColor) {
      const o = this._selectedColor.trim().toLowerCase(), i = this._variants.filter(
        (n) => n[`op${this._colorIndex}`]?.trim().toLowerCase() === o
      );
      i.length && (s = i);
    }
    let r = "";
    t.forEach((o, i) => {
      const n = i.trim().toLowerCase(), c = s.some(
        (l) => l[`op${this._sizeIndex}`]?.trim().toLowerCase() === n && l.av
      ), d = s.find(
        (l) => l[`op${this._sizeIndex}`]?.trim().toLowerCase() === n && l.av
      ) ?? s.find(
        (l) => l[`op${this._sizeIndex}`]?.trim().toLowerCase() === n
      ) ?? o;
      r += `<li class="qbm-size" role="option">
        <button
          type="button"
          class="qbm-size__btn${c ? "" : " qbm-size__btn--unavailable"}"
          data-variant-id="${d.id}"
          data-size-value="${this._esc(i)}"
          data-pim-product-id="${this._esc(d.pid)}"
          ${c ? "" : "disabled"}
        >${this._esc(i)}</button>
      </li>`;
    }), e.innerHTML = r;
  }
  // ─── Add to cart ───────────────────────────────────────────────────────────
  async _addToCart(e) {
    const t = e.dataset.variantId;
    if (!t) return;
    const s = {
      _pim_product_id: e.dataset.pimProductId ?? ""
    };
    this._submitAddToCart(e, t, s);
  }
  /**
   * Shared add-to-cart request + success/error UI for both the single-axis
   * and multi-axis (paged) flows.
   * @param {HTMLButtonElement} btn
   * @param {string} variantId
   * @param {object} properties
   */
  async _submitAddToCart(e, t, s) {
    if (t) {
      (!s || !s._pim_product_id) && window.Sentry?.captureMessage(
        `Quick Buy (mobile): missing _pim_product_id (variant ${t})`,
        {
          level: "error",
          extra: { variantId: t, productHandle: this.dataset?.productHandle }
        }
      ), e.setAttribute("data-adding", ""), this._feedback && (this._feedback.textContent = "");
      try {
        const r = [];
        document.querySelectorAll("cart-items-component").forEach((c) => {
          c instanceof HTMLElement && c.dataset.sectionId && r.push(c.dataset.sectionId);
        });
        const i = await (await fetch(
          typeof Theme < "u" && Theme.routes?.cart_add_url || "/cart/add.js",
          {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({
              items: [{ id: parseInt(t, 10), quantity: 1, properties: s }],
              sections: r.join(",")
            })
          }
        )).json();
        if (e.removeAttribute("data-adding"), i.status) {
          this._feedback && (this._feedback.textContent = i.message || "Could not add to cart"), setTimeout(() => {
            this._feedback && (this._feedback.textContent = "");
          }, 4e3);
          return;
        }
        e.setAttribute("data-added", "");
        const n = e.dataset.sizeValue ?? e.dataset.fitValue ?? e.textContent;
        if (e.textContent = "✓", document.dispatchEvent(
          new CustomEvent("cart:update", {
            bubbles: !0,
            detail: {
              resource: i,
              sourceId: "quick-buy-mobile",
              data: {
                source: "product-form-component",
                itemCount: 1,
                productId: this.dataset.productId,
                sections: i.sections
              }
            }
          })
        ), this._close(), document.body?.dataset.template !== "cart") {
          const c = document.querySelector("cart-drawer");
          c && typeof c.openDrawer == "function" ? c.openDrawer() : c && c.setAttribute("aria-expanded", "true");
        }
        setTimeout(() => {
          e.removeAttribute("data-added"), e.textContent = n;
        }, 1200);
      } catch (r) {
        e.removeAttribute("data-adding"), this._feedback && (this._feedback.textContent = "Something went wrong"), setTimeout(() => {
          this._feedback && (this._feedback.textContent = "");
        }, 4e3), console.error("[QuickBuyMobile] Add to cart error:", r);
      }
    }
  }
}
customElements.get("quick-buy-mobile") || customElements.define("quick-buy-mobile", z);
const m = ".product-media__video", y = /* @__PURE__ */ new WeakSet(), w = /* @__PURE__ */ new WeakMap();
let h = null, v = null;
const p = () => !!v?.matches, P = (a) => {
  const e = a.closest("slideshow-slide");
  return e ? e.getAttribute("aria-hidden") === "false" : !0;
}, g = (a) => {
  a.pause();
}, O = (a) => {
  if (p()) return;
  const e = a.play();
  e !== void 0 && e.catch(() => {
  });
}, C = (a) => {
  w.get(a) && P(a) && !p() ? O(a) : g(a);
}, S = () => h || (h = new IntersectionObserver(
  (a) => {
    for (const e of a) {
      const t = e.target;
      t instanceof HTMLVideoElement && (w.set(t, e.isIntersecting), C(t));
    }
  },
  { rootMargin: "50px 0px", threshold: 0.25 }
), h), _ = (a = document) => {
  const e = a.querySelectorAll(m);
  for (const t of e)
    if (t instanceof HTMLVideoElement && !y.has(t)) {
      if (y.add(t), t.muted = !0, t.playsInline = !0, t.setAttribute("aria-hidden", "true"), p()) {
        g(t);
        continue;
      }
      S().observe(t);
    }
}, H = (a) => {
  const e = a.querySelectorAll(m);
  for (const t of e)
    t instanceof HTMLVideoElement && C(t);
}, V = () => {
  const a = document.querySelectorAll(m);
  for (const e of a)
    e instanceof HTMLVideoElement && g(e);
}, R = () => {
  if (p()) {
    V(), h && (h.disconnect(), h = null);
    return;
  }
  const a = document.querySelectorAll(m);
  for (const e of a)
    e instanceof HTMLVideoElement && S().observe(e);
}, b = () => {
  v = window.matchMedia("(prefers-reduced-motion: reduce)"), v.addEventListener("change", R), _(), new MutationObserver((e) => {
    for (const t of e) {
      if (t.type === "attributes") {
        const s = t.target;
        s instanceof Element && s.matches("slideshow-slide") && H(s);
        continue;
      }
      for (const s of t.addedNodes)
        s instanceof Element && (s.matches?.(m) ? _(s.parentElement ?? document) : s.querySelector?.(m) && _(s));
    }
  }).observe(document.documentElement, {
    childList: !0,
    subtree: !0,
    attributes: !0,
    attributeFilter: ["aria-hidden"]
  });
};
document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", b, {
  once: !0
}) : b();
